export default "__VITE_ASSET__CqI9A8Kc__"